/* eslint-disable no-useless-catch */
import {qs} from '@shared/helpers/queryString'
import {SchemasOrderSeller} from '@shared/schemas/order'

import getApi from '@web/helpers/api'

import {ApiBaseUrl, ApiUrlInfo} from '../constants'

import {SellerOrderSheetGiftFriendsSessionResponse} from './response'

const api = getApi(ApiBaseUrl)

async function createWrapper<T>(apiPromise: Promise<{data: {result: T}}>): Promise<T> {
    try {
        const {
            data: {result},
        } = await apiPromise
        return result
    } catch (e) {
        throw e
    }
}

/** 주문서 조회 */
async function getSellerOrderSheet({
    orderSheetId,
    backUrl,
}: {
    /** 주문서 ID */
    orderSheetId: string
    /** backUrl */
    backUrl?: string
}) {
    const userAgent = navigator.userAgent
    return createWrapper<SchemasOrderSeller['/']['response'] | SellerOrderSheetGiftFriendsSessionResponse>(
        api.get(ApiUrlInfo.orderSheet, {
            params: {orderSheetId, userAgent, ...(backUrl ? {backUrl} : {})},
            validateStatus: (status) => {
                return status === 302 || status < 300
            },
        }),
    )
}

/** 맴버십 퀵조인 */
async function fetchMembershipQuickJoin({
    isAgreeAd,
}: {
    /** 동의 여부 */
    isAgreeAd: boolean
}) {
    return createWrapper<SchemasOrderSeller['/memberships/join']['response']>(
        api.post(
            qs.stringifyUrl({
                url: ApiUrlInfo.membershipJoin,
                query: {
                    isAgreeAd,
                },
            }),
        ),
    )
}

/** 카드 간편결제 정보 재조회 */
async function getCardEasyPays() {
    return createWrapper<SchemasOrderSeller['/cardEasyPays']['response']>(
        api.get(ApiUrlInfo.payments.cardEasyPaysReload),
    )
}

/** 계좌 간편결제 정보 재조회 */
async function getBankEasyPays() {
    return createWrapper<SchemasOrderSeller['/bankEasyPays']['response']>(
        api.get(ApiUrlInfo.payments.bankEasyPaysReload),
    )
}

export default {
    getSellerOrderSheet,
    fetchMembershipQuickJoin,
    getCardEasyPays,
    getBankEasyPays,
}
